import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={19}
      fill="none"
      viewBox="0 0 19 19"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <g fill="currentColor" clipPath={`url(#${id})`}>
        <path d="M18.51 7.85c-.208-.313-.468-.552-.978-1.03l-.031-.032c-.084-.083-.146-.135-.188-.188a.97.97 0 0 1-.229-.551v-.385c.021-.636.042-.99-.041-1.343a2.999 2.999 0 0 0-2.332-2.333c-.344-.072-.677-.062-1.343-.041h-.084c-.156 0-.24.01-.312 0a1 1 0 0 1-.552-.23l-.229-.228-.062-.073c-.427-.458-.656-.708-.958-.906-1-.656-2.3-.656-3.3 0-.302.198-.531.437-1.02.968l-.063.063a1.396 1.396 0 0 1-.177.177.97.97 0 0 1-.552.229H5.632c-.593-.021-.958-.031-1.322.041A3.013 3.013 0 0 0 1.978 4.32c-.073.354-.062.708-.042 1.416v.333c-.02.209-.104.396-.229.563-.041.052-.104.104-.218.218l-.063.063c-.458.437-.718.666-.916.978-.656 1-.656 2.301 0 3.3.198.313.458.552.979 1.042l.03.031c.084.083.147.135.188.188a.97.97 0 0 1 .23.551v.385c-.021.636-.042.99.041 1.344a2.985 2.985 0 0 0 2.332 2.332c.364.083.74.062 1.354.041h.072c.157 0 .24-.01.323 0a1 1 0 0 1 .552.23l.229.228.073.084c.427.447.656.697.958.895.489.323 1.062.49 1.655.49a2.96 2.96 0 0 0 1.645-.49c.302-.198.53-.437 1.02-.968l.063-.063c.072-.083.125-.135.177-.177a.97.97 0 0 1 .541-.229h.396c.666.021 1 .031 1.353-.041a3.012 3.012 0 0 0 2.332-2.332c.073-.354.063-.708.042-1.416v-.333a.97.97 0 0 1 .229-.552c.041-.052.104-.104.218-.219l.052-.052c.448-.417.719-.677.927-.979.656-1 .656-2.3 0-3.3l-.01-.031Zm-3.435 5.59c.01.438.02.73 0 .844a1.003 1.003 0 0 1-.78.78c-.136.032-.563.011-.896 0-.313 0-.469-.01-.614 0a3 3 0 0 0-1.666.688c-.125.104-.24.229-.469.468-.291.313-.5.531-.604.604a1.01 1.01 0 0 1-1.103 0c-.104-.062-.302-.281-.614-.614a5.573 5.573 0 0 0-.458-.448 2.97 2.97 0 0 0-1.645-.687c-.084 0-.167-.01-.281-.01H5.57c-.27.01-.719.03-.864 0a1.003 1.003 0 0 1-.781-.781c-.02-.115-.01-.417 0-.896 0-.291.01-.458 0-.624a2.94 2.94 0 0 0-.687-1.656c-.104-.125-.219-.229-.458-.458-.292-.27-.542-.51-.615-.614a1.01 1.01 0 0 1 0-1.103c.073-.105.323-.344.646-.636.219-.208.333-.312.427-.426a2.94 2.94 0 0 0 .687-1.656c.01-.166.01-.333 0-.676-.01-.438-.02-.73 0-.844.083-.395.385-.697.78-.78.105-.032.386-.01.813 0h.052c.323.01.479.01.645 0a2.94 2.94 0 0 0 1.656-.688c.125-.104.24-.229.468-.468.302-.323.5-.531.604-.604a1.01 1.01 0 0 1 1.104 0c.093.062.291.27.614.614.218.23.333.344.458.448a2.94 2.94 0 0 0 1.666.687c.145.01.301.01.666 0 .437-.01.718-.02.843 0 .396.083.698.385.781.78.02.115.01.417 0 .896 0 .292-.01.458 0 .625a2.94 2.94 0 0 0 .687 1.655c.094.115.208.219.458.458.323.292.552.51.614.615.22.333.22.77 0 1.103-.062.104-.28.312-.645.635-.219.208-.333.313-.427.427a2.94 2.94 0 0 0-.687 1.655 7.06 7.06 0 0 0 0 .677v.01Z" />
        <path
          fillRule="evenodd"
          d="M9.026 12.868a.887.887 0 0 1-1.28 0l-2.499-2.592a.956.956 0 0 1 0-1.323.875.875 0 0 1 1.27 0l1.864 1.927 4.091-4.238a.874.874 0 0 1 1.27 0 .956.956 0 0 1 0 1.322l-4.726 4.894.01.01Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <path fill="currentColor" d="M0 0h19v19H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
